import axios from 'axios';
import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import { objectToFormData } from '../../../axios-helper';

Vue.use(VueTheMask);

window.toggleMenuLogin = function() {
    const el = document.getElementById('loginMenuCard');
    const elBG = document.getElementById('loginMenuBackground');
    if(el.classList.contains('payt-v-hide')) {
        el.classList.remove('payt-v-hide');
        elBG.classList.remove('payt-v-hide');
    } else {
        el.classList.add('payt-v-hide');
        elBG.classList.add('payt-v-hide');
    }
};

new Vue({
    el: '#loginMenuCard',
    data() {
        return {
            doc: '',
            email: '',
            loading: false,
            showError: false,
        };
    },
    watch: {
        doc() {
            if(this.doc.length === 11 && /^\d+$/.test(this.doc)) {
                this.doc = this.doc.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
            }
        }
    },
    methods: {
        async submit() {
            const url = document.getElementById('formUserLogin').getAttribute('action');
        
            this.loading = true;
            try {
                const r = await axios.post(
                    url,
                    objectToFormData({
                        'email': this.email,
                        'cpf': this.doc
                    }),
                    { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
                );
                
                if(r.data.success) {
                    window.location.href = r.data.redirectUrl;
                } else {
                    this.showError = true;
                    this.loading = false;
                }
            } catch(ex) {
                this.showError = true;
                this.loading = false;
            }
        }
    }
});
